<div class="title-page d-flex justify-content-between">
    <BreadcrumbComponent></BreadcrumbComponent>
</div>
<div style="background: #f7f8f9;height: 100%">
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
                    <span>{{ messError }}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="list-partners-component">
                    <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-center flex-column align-items-center">
                        <div class="col-sm-4">
                            <InputTextNormal
                                    :label="dataSyncKiotViet.retailer.label"
                                    :id="dataSyncKiotViet.retailer.id"
                                    :placeholder="dataSyncKiotViet.retailer.placeholder"
                                    :value-default="dataSyncKiotViet.retailer.value"
                                    @inputValue="onChange($event, dataSyncKiotViet.retailer.id)"
                                    :error-text="dataSyncKiotViet.retailer.error"
                                    :is-error="dataSyncKiotViet.retailer.isError"
                                    @blur="validateForm($event, dataSyncKiotViet.retailer.id)"
                                    :required="dataSyncKiotViet.retailer.required"
                            ></InputTextNormal>
                        </div>
                        <div class="col-sm-4">
                            <InputTextNormal
                                    :label="dataSyncKiotViet.client_id.label"
                                    :id="dataSyncKiotViet.client_id.id"
                                    :placeholder="dataSyncKiotViet.client_id.placeholder"
                                    :value-default="dataSyncKiotViet.client_id.value"
                                    @inputValue="onChange($event, dataSyncKiotViet.client_id.id)"
                                    :error-text="dataSyncKiotViet.client_id.error"
                                    :is-error="dataSyncKiotViet.client_id.isError"
                                    @blur="validateForm($event, dataSyncKiotViet.client_id.id)"
                                    :required="dataSyncKiotViet.client_id.required"
                            ></InputTextNormal>
                        </div>
                        <div class="col-sm-4">
                            <InputTextNormal
                                    :label="dataSyncKiotViet.client_secret.label"
                                    :id="dataSyncKiotViet.client_secret.id"
                                    :placeholder="dataSyncKiotViet.client_secret.placeholder"
                                    :value-default="dataSyncKiotViet.client_secret.value"
                                    @inputValue="onChange($event, dataSyncKiotViet.client_secret.id)"
                                    :error-text="dataSyncKiotViet.client_secret.error"
                                    :is-error="dataSyncKiotViet.client_secret.isError"
                                    @blur="validateForm($event, dataSyncKiotViet.client_secret.id)"
                                    :required="dataSyncKiotViet.client_secret.required"
                            ></InputTextNormal>
                        </div>
                        <div class="col-sm-2 d-flex flex-column justify-content-end">
                            <ButtonSearchComponent label="Connect Kiotviet"
                                                   @click="connectKiotviet"></ButtonSearchComponent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

